import { SortType } from './../interfaces/sort-type';

export const SORT_TYPES: SortType[] = [
  { value: 'fdate', direction: 'desc', label: 'Date of file' },
  { value: 'ftype', direction: 'desc', label: 'File type' },
  { value: 'fileDesc', direction: 'desc', label: 'File content' },
  { value: 'lastModified', direction: 'desc', label: 'Last Modified' },
  { value: 'uploadedDate', direction: 'desc', label: 'Date Uploaded' }
];
